export const midPoint = (c1: number[], c2: number[]) => [(c1[0] + c2[0]) / 2, (c1[1] + c2[1]) / 2]